import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { TransferPage } from '../transfer/transfer';
import { WithdrawalPage } from '../withdrawal/withdrawal';
import { RoomdetailPage } from '../roomdetail/roomdetail';

/**
 * Generated class for the CashroomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cashroom',
  templateUrl: 'cashroom.html',
})
export class CashroomPage {

    segment: string = 'all';

	loginId: string;
	email: string;
    api_key: string;
    version: string;

	list: any = [];
	name: any = [];
    
	coin_unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;
    
    balance: string;
	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
        private http: HttpService,
		public app: App
	) {
		
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "cashroom");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init('all');
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).cashroom;
	}

	_init(name) {		
		this.list = [];
		
        let url = "room/cash";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            name: name
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.balance = res.balance;
                this.name = res.name;

                if (res.list != undefined) {   
                    this.list = res.list;
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

    _list_detail(item) {
        let modal = this.modalCtrl.create(RoomdetailPage, {name: item.name, date: item.date, from: "cash"});
        modal.present();
        modal.onDidDismiss( name => {
            if (name != '') {
                this.segment = name;
            }
        });
    }

    _click(event) {
        if (event == "transfer") {
            this.navCtrl.push(TransferPage);
        }

        if (event == "withdrawal") {
            this.navCtrl.push(WithdrawalPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/cashroom/cashroom.ts